export class BrandChannelModel {
    id?:number
    idChannel?:number
    idBrand?:number
    idExternalChannel?:string

    constructor(bc?: Partial<BrandChannelModel>) {
        Object.assign(this, bc)
    }
}
